<template>
    <div id="content" class="content">

        <p>问题和意见</p>
        <van-field v-model.trim="formData.opinion" rows="5" autosize type="textarea" maxlength="200" placeholder="请输入10个字以上的问题描述，以便我们提供更好的帮助" show-word-limit />

        <p>联系电话</p>
        <van-field v-model.trim="formData.phone" type="tel" placeholder="选填，便于我们跟您联系" />

        <div class="button-content">
            <van-button color="#E8541E" @click="commitAction">提  交</van-button>
        </div>

    </div>
</template>

<script>
import { wxRequest } from '@/api/user'
import { Toast } from 'vant';
export default {
    data(){
        return {
            formData:{
	    		opinion:'',
		    	phone:''
	    	}
        }
    },
    methods: {
        commitAction(){
            let checkPhone = this.checkPhoneNumber(this.formData.phone);
            if(!this.formData.opinion){
                Toast.fail('请输入问题和意见内容');
                return;
            }
            if(checkPhone){
                Toast.fail(checkPhone);
                return;
            }

            wxRequest('xxtx/app/user/opinion', this.formData, 'post').then(res => {
                if(res.data.code == 200){
                    Toast.success(res.data.message);
                    this.formData.opinion = '';
                    this.formData.phone = '';
                }else {
                    Toast.fail(res.data.message);
                }
            })
        },

        checkPhoneNumber(phoneNumber){
            let message = null;
            if(!phoneNumber){
                return false;
            }
            if(!(/^1[3456789]\d{9}$/.test(phoneNumber))){
                message = '请输入正确格式的手机号'
            } 
            return message;
        }
    }
}
</script>

<style>
.content{
    height: 100%;
    background: #eaeae6;
}
.content h1{
    font-size: 0.8rem;
    padding:16px 0 0 0;
    text-align: center;
}
.content p{
    padding:30px 16px 10px 16px;
    font-size: 0.8rem;
}
.content .img-content{
    padding:10px 16px;
    background: #fff;
}
.content .button-content{
    display: flex;
    justify-content: center;
    padding: 20px 0;
    background: #eaeae6;
}
</style>